import React from "react";
import { css, cx } from "emotion";

import { buttonStyle, buttonGreenStyle } from "./style";

const Button = ({ green = false, children, className, ...props } = props) => {
	const Tag = props.href ? "a" : "button";

	return (
		<Tag
			className={cx(
				css`
					${buttonStyle};
				`,
				!!className && className,
				{
					[css`
						${buttonGreenStyle};
					`]: green
				}
			)}
			{...props}
		>
			{children}
		</Tag>
	);
};

export default Button;
